import { jwtDecode } from "jwt-decode";
import "../styles/PlayerHoldings.css"
import { PerPlayerStockItem } from "./items/PerPlayerStockItem"
export const PlayerHoldings = ({ player, size, self }) => {
    let photoUrl = null;
    let title = null;
    if (self) {
        title = "Your Holdings"
        const localDetails = jwtDecode(localStorage.getItem("token"));
        photoUrl = localDetails.picture
    }
    return (<div className={`player-holdings-container-${size}`}>
        <div style={{ display: "flex" }}>
            <img src={photoUrl || player.photoUrl} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
            <div className={`player-holdings-header`}>
                {title || player.name}
            </div>
        </div>
        <div style={{
            display: size === "lg" ? "block" : "flex", overflowX: size === "lg" ? "hidden" : "auto", msOverflowStyle: "none", scrollbarWidth: "none"
        }}>
            {player.stocks && Object.entries(player.stocks).map(([key, value]) => {
                return <PerPlayerStockItem key={`player_${player.id}_stock_${key}`} size={size} company={key} holdings={value} />
            })}
            {Object.keys(player.stocks).length === 0 && <p style={{ textAlign: "center", width: "100%" }}>No holdings</p>}
        </div>
        {self && <p style={{ marginTop: "5px", marginBottom: "-5px", fontWeight: "bold", textAlign: "center" }} onClick={() => { window.location.href = "/all-player-holdings" }}>View all player holdings</p>}
    </div>)
}